import React from 'react';
import { buildPaginationFromResponse } from '../../../services/pagination';
import usePages from '../../../hooks/usePages';
import { getGetInspectionDetailQueryKey, useGetInspectionRemoteSubmissionLocationsSuspense, useMarkRemoteSubmissionLocationAsRead, } from '../../../services/api/generated/client';
import { unwrapModel } from '../../../services/api/unwrapModel';
import RemoteSubmissionsTable from './RemoteSubmissionsTable';
import useExpandableAccordion from '../../../hooks/useExpandableAccordion';
import useGenericMutationUseCase from '../../../hooks/usecases/generic/useGenericMutationUseCase';
import { queryClient } from '../../../services/api/query/queryClient';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
const RemoteSubmissionsTableWrapper = ({ inspection, canEdit }) => {
    const { handleExpand, expandedIndex } = useExpandableAccordion();
    const { isShare } = useInspectionDetailContext();
    const { incrementPage, decrementPage, page } = usePages(() => {
        handleExpand(undefined);
    });
    const { data: response, isFetching, refetch, } = useGetInspectionRemoteSubmissionLocationsSuspense(inspection.id, {
        page,
        should_paginate: 1,
    });
    const markLocationAsRead = useGenericMutationUseCase(useMarkRemoteSubmissionLocationAsRead);
    const handleRowExpanded = (index, location, isExpanded) => {
        handleExpand(index);
        if (isExpanded || !!location.read_at || isShare)
            return;
        markLocationAsRead.execute({
            id: location.id,
        }, undefined, {
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: getGetInspectionDetailQueryKey(inspection.id),
                });
                refetch();
            },
        });
    };
    const remoteSubmissionLocations = unwrapModel(response);
    const pagination = buildPaginationFromResponse(response, incrementPage, decrementPage);
    return (React.createElement(RemoteSubmissionsTable, { remoteSubmissionLocations: remoteSubmissionLocations, isFetching: isFetching, pagination: pagination, expandedIndex: expandedIndex, handleExpand: handleRowExpanded, canEdit: canEdit }));
};
export default RemoteSubmissionsTableWrapper;
